import React from 'react';

import { promos } from 'api';
import { COLORS } from 'config/constants';

import FeedbackList from 'components/FeedbackList';
import ActionBar from 'components/ActionBar';
import Button from 'components/Button';
import { PeopleIcon } from 'components/Icons';
import NoDataDisplay from 'components/NoDataDisplay';
import { GetLabelAndViewerQuery } from 'gql/graphql';

interface LabelFeedbackProps {
  label: NonNullable<GetLabelAndViewerQuery['label']>;
  isLabelManager: boolean;
  hasReleasesOnLabel: boolean;
  isAdminUser: boolean;
}

const LabelFeedback = ({
  label,
  isLabelManager,
  hasReleasesOnLabel,
  isAdminUser
}: LabelFeedbackProps) => {
  if (!isLabelManager && !hasReleasesOnLabel && !isAdminUser) {
    return (
      <div className="container-fluid mt-3">
        <NoDataDisplay text={`You have not released music yet on ${label.name}.`} />
      </div>
    );
  }

  const locationProps = {
    pathname: '/labels/share-feedback',
    state: { modal: true, shareURL: window.location.href }
  };

  return (
    <>
      <ActionBar
        renderActions={
          !isLabelManager
            ? null
            : () => (
                <Button
                  color={Button.COLORS.NEUTRAL}
                  to={locationProps}
                  data-testid="LabelFeedback-share"
                >
                  <PeopleIcon className="mr-1" size={12} color={COLORS.GRAY_DARK} />
                  Share Feedback
                </Button>
              )
        }
      />

      <FeedbackList
        paginationReducer="feedback.byLabelId"
        noFeedbackMessage={
          isLabelManager
            ? "Your label hasn't received any feedback yet."
            : `You have not received any feedback yet on ${label.name}.`
        }
        paginationReducerId={label.id}
        fetchApi={({ page }: { page: number | undefined }) =>
          promos.getLabelReactions({ labelId: label.id, page })
        }
      />
    </>
  );
};

LabelFeedback.SELECTORS = {
  SHARE_BUTTON: '[data-testid=LabelFeedback-share]'
};

export default LabelFeedback;
